export const MESSAGE_FILTERS = {
  ALL_VALUE: '*'
}
